<script setup lang="ts">
import { useContactStore } from '@/store/contact';
import StfInput from '@/ui/input/StfInput.vue';
import {storeToRefs} from 'pinia';

const contactStore = useContactStore();
const { email, names, emailError, namesError, emailIsValid, namesIsValid } = storeToRefs(contactStore);

</script>

<template>
    <StfInput v-model="names" label="Contact Name" placeholder="Contact Name" :error="namesError" :success="namesIsValid"/>
    <StfInput v-model="email" label="Contact Email" placeholder="Contact Email" :error="emailError" :success="emailIsValid"/>
</template>
